import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { FeedbackService } from '../feedback.service';
import { Feedback, FeedbackType } from '../feedback';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class FeedbackComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  feedback: Feedback;
  error = FeedbackType.Error;

  constructor(private feedbackService: FeedbackService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.feedbackService.getError().subscribe((error) => {
      this.handleNotification(error);
    }));
    this.subscriptions.add(this.feedbackService.getSuccess().subscribe((sucess) => {
      this.handleNotification(sucess);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


  /**
   * This method handle feedback
   *
   * @param notification
   */
  handleNotification(notification: Feedback) {
    this.feedback = notification;
  }
}

